import React from 'react';
import { ActivityIndicator as RNPActivityIndicator } from 'react-native-paper';

export type ActivityIndicatorProps = React.ComponentProps<typeof RNPActivityIndicator>;

export default function ActivityIndicator(props: ActivityIndicatorProps) {
  return <RNPActivityIndicator {...props} />;
}
